<template>
    <BaseModal
        @close="handleClose"
    >
        <template #header>
            <h3 id="base-modal-title" class="remove-card__title" tabindex="-1" ref="removeCardTitle">
                {{ $ml.with(0, card.brand + ' ' + card.type + ' ' + card.lastDigits).get('removeCardModalTitle') }}
            </h3>
        </template>

        <span class="remove-card__subtitle">{{ $ml.get('removeCardModalSubtitle') }}</span>

        <template #footer>
            <button class="remove-card__btn remove-card__btn--cancel" @click="handleClose" ref="cancelBtn">
                {{ $ml.get('cancel') }}
            </button>
            <button class="remove-card__btn remove-card__btn--remove" @click="removeCard" :disabled="loading">
                <ClipLoader v-if="loading" color="#fff" size="14px" />
                <span v-else>{{ $ml.get('remove') }}</span>
            </button>
        </template>
    </BaseModal>
</template>

<script>
    import BaseModal from '@/components/template/BaseModal';
    import ClipLoader from 'vue-spinner/src/ClipLoader';
    
    export default {
        components: {
            BaseModal,
            ClipLoader
        },

        data() {
            return {
                loading: false,
            };
        },

        props: {
            card: {
                type: Object,
                required: true,
            },
        },

        mounted() {
            // Foco automático no título para leitores de tela
            this.$nextTick(() => {
                if (this.$refs.removeCardTitle) {
                    this.$refs.removeCardTitle.focus();
                }
            });
            // Fechar com ESC
            document.addEventListener('keydown', this.handleEsc);
        },

        beforeDestroy() {
            document.removeEventListener('keydown', this.handleEsc);
        },
        
        methods: {
            handleClose() {
                this.$emit('close');
            },
            handleRemove() {
                this.$emit('remove');
            },
            handleEsc(e) {
                if (e.key === 'Escape') {
                    this.handleClose();
                }
            },
            async removeCard() {
                if(this.loading) return;

                this.loading = true;

                try {
                    await this.$store.dispatch('dataOnFile/removeCard');
                    this.handleClose();
                } catch (error) {
                    console.error('Error removing card:', error);
                } finally {
                    this.loading = false;
                }
			}
        },
    };
</script>

<style scoped lang="scss">

    .remove-card {
        &__title {
            font-size: 1.25rem;
            font-weight: 700;
            color: #2F363E;
        }

        &__subtitle {
            font-size: 1rem;
            font-weight: 500;
            color: #454F5C;
        }

        &__btn {
            padding: 10px 29px;
            font-weight: 600;
            border: none;
            border-radius: 24px;
            cursor: pointer;
            transition: background 0.2s;
        }

        &__btn--cancel {
            background-color: #EFF1F3;
            color: #000000;

            &:hover, &:focus {
                background-color: #e0e0e0;
                outline: 2px solid #1976d2;
            }
        }

        &__btn--remove {
            min-width: 132px;
            background-color: #DC392A;
            color: white;

            &:hover, &:focus {
                background-color: #d32f2f;
                outline: 2px solid #1976d2;
            }
        }
    }

</style>